import React, { useState } from "react";
import { useSelector } from "react-redux";
import { exportToExcel } from "../../api";
import { isLoading } from "../../redux/loadingSlice";
import { LeftBanner } from "../../layout/LeftBanner";
import { NavBar } from "../../layout/NavBar";
import { AddNotification, ExportRecord, PageLoader } from "../core";
import { ForbiddenPage } from "../core/ForbiddenPage";
import { AdminList } from "./AdminList";
import { ServiceOfferingList } from "./ServiceOfferingsList";

export const Admin = () => {
  const [activeTab, setActiveTab] = useState("admin");
  const [isExported, setIsExported] = useState(false);
  let profile = sessionStorage.getItem("profile");
  const loading = useSelector(isLoading);
  const exportData = () => {
    exportToExcel();
    setIsExported(true);
  };

  return (
    <div>
      {!loading && <PageLoader />}
      {!(profile && profile.role !== "Read") ? (
        <ForbiddenPage />
      ) : (
        <>
          <NavBar />
          <div className="flex mr-4">
            <div className="flex-none w-64">
              <LeftBanner />
            </div>
            <div className="flex-1 pr-24">
              <div className="text-sm font-medium text-gray-500 border-b border-gray-200 dark:text-gray-400 dark:border-gray-700">
                <ul
                  className="flex flex-wrap -mb-px justify-between w-full"
                  id="default-styled-tab"
                >
                  <li className="me-2">
                    <button
                      className={`inline-block p-4 border-b-2 pb-5 ${
                        activeTab === "admin"
                          ? "active border-teal-600 text-teal-600 dark:text-teal-500 dark:border-teal-500"
                          : "border-transparent text-gray-500 hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300"
                      } rounded-t-lg`}
                      id="admin-styled-tab"
                      type="button"
                      role="tab"
                      onClick={() => setActiveTab("admin")}
                    >
                      Add/Update Admin
                    </button>
                  </li>
                  <li className="me-2">
                    <button
                      className={`inline-block p-4 border-b-2 pb-5 ${
                        activeTab === "service"
                          ? "active border-teal-600 text-teal-600 dark:text-teal-500 dark:border-teal-500"
                          : "border-transparent text-gray-500 hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300"
                      } rounded-t-lg`}
                      id="service-styled-tab"
                      data-tabs-target="#styled-service"
                      type="button"
                      role="tab"
                      onClick={() => setActiveTab("service")}
                    >
                      Add Service Offering
                    </button>
                  </li>
                  <li className="ml-auto">
                    <button
                      onClick={exportData}
                      className="inline-flex p-4 items-center justify-center border-b-2 border-transparent rounded-t-lg hover:text-sky-800 hover:border-sky-800 dark:hover:text-gray-800 group"
                      data-testid="export-data"
                    >
                      <ExportRecord />
                      Export Complete Service Provider Data
                    </button>
                  </li>
                </ul>
                <AddNotification
                  message={"Success! Service Providers exported successfully"}
                  type={"success"}
                  show={isExported}
                  onClose={() => setIsExported(false)}
                />
              </div>
              <div id="default-styled-tab-content" className="mt-8 mb-8">
                {activeTab === "admin" && <AdminList />}
                {activeTab === "service" && <ServiceOfferingList />}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
